import NProgress from 'nprogress';

export default NProgress.configure({ showSpinner: false });
